import { atom } from "recoil"
import { GroupMember } from "src/types/organization/group/GroupMember"

export const addedMembersState = atom<GroupMember[]>({
  key: "atoms/organization/group/addedMembersState",
  default: [],
})
